import React, {Component, Fragment} from 'react';
//import {I18n} from "react-redux-i18n";
//import moment from "moment-timezone";
import {ContentItem} from "../Blocks/FlyOutBlock.js";
import moment from "moment";

//moment.tz.setDefault("Europe/Stockholm");

class FlyOutFeedbackItem extends Component {

    state = {
        isExpanded: false
    };

    expand = () => {
        this.setState({
            isExpanded: true
        });
    };

    collapse = () => {
        this.setState({
            isExpanded: false
        });
    };

    render() {

        const {item, initialsFromProviderName} = this.props;
        const showTo = false;
        return (
            <Fragment>

                    <ContentItem key={item.itemId} badge={initialsFromProviderName} isFeedback="1">
                        <div className={'flyout-request'}>

                            <div className={'flyout-block-item-content-header'}>
                                <div className={'flyout-block-item-content-header-from'}>
                                    From
                                </div>
                                {item.providerName}
                                <span
                                    className={'flyout-block-item-content-header-divider'}/>
                                {moment.unix(item.receivedOn).format("DD-MM-YY, HH:mm")}
                            </div>
                            {showTo &&
                            <div className="feedback__to">
                                To: {item.receiverName}
                            </div>
                            }
                            <div className={'flyout-block-item-content-text'}>
                                {item.comment}
                            </div>

                            {!this.state.isExpanded && item.replies && item.replies.length !== 0 &&
                            <div className={'flyout-feedback__toggle--expand'}
                                 onClick={this.expand}>
                                View
                                <i className="nuuday-awave--far nuuday-awave--fa-angle-down"/>
                            </div>
                            }

                        </div>

                        {this.state.isExpanded && item.replies && item.replies.length !== 0 &&
                        <div className={'flyout-replies'}>
                            {item.replies.map((reply, key) => {
                                return (
                                    <div className="reply" key={key}>
                                        <div className="reply__author">{reply.childProviderName}</div>
                                        <div className="reply__comment">{reply.childComment}</div>
                                    </div>
                                );
                            })}
                            <div className={'flyout-feedback__toggle--collapse'}
                                 onClick={this.collapse}>
                                Hide
                                <i className="nuuday-awave--far nuuday-awave--fa-angle-up"/>
                            </div>
                        </div>
                        }
                    </ContentItem>

            </Fragment>
        );
    }
}

export default FlyOutFeedbackItem;



// WEBPACK FOOTER //
// ./src/frontend/components/UI/FlyOutFeedbackItem.js